import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "cooperation" };
const _hoisted_2 = { class: "info-container max-width" };
const _hoisted_3 = { class: "cooperation-card" };
const _hoisted_4 = { class: "cooperation-info" };
const _hoisted_5 = { class: "info-row" };
const _hoisted_6 = { class: "info-item" };
const _hoisted_7 = { class: "info-value" };
const _hoisted_8 = { class: "info-item" };
const _hoisted_9 = { class: "info-value" };
const _hoisted_10 = { class: "cooperation-qr" };
const _hoisted_11 = ["src"];
import { ref, onMounted } from "vue";
import post from "./components/post.vue";
import { getCooperationInfo } from "@/api/cooperation";
import aboutImg from "@/assets/image/about.png";
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        const postRef = ref();
        const clickCount = ref(0);
        const coopData = ref({});
        const refreshData = async () => {
            try {
                const res = await getCooperationInfo();
                coopData.value = res.data;
            }
            catch {
                // 暂无数据
            }
        };
        onMounted(() => {
            refreshData();
        });
        const handleEdit = () => {
            const token = localStorage.getItem("token");
            if (!token) {
                return;
            }
            clickCount.value++;
            if (clickCount.value >= 2) {
                postRef.value.show(coopData.value);
                clickCount.value = 0;
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("section", {
                    class: "top-container",
                    onClick: handleEdit
                }, [
                    _createElementVNode("div", _hoisted_2, [
                        _cache[3] || (_cache[3] = _createElementVNode("p", { class: "en-title" }, "BUSINESS", -1)),
                        _cache[4] || (_cache[4] = _createElementVNode("h2", { class: "cn-title" }, "商务合作", -1)),
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("div", _hoisted_6, [
                                        _cache[0] || (_cache[0] = _createElementVNode("p", { class: "info-label" }, "联系电话", -1)),
                                        _createElementVNode("p", _hoisted_7, _toDisplayString(coopData.value.contactPhone || "-"), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_8, [
                                        _cache[1] || (_cache[1] = _createElementVNode("p", { class: "info-label" }, "联系邮箱", -1)),
                                        _createElementVNode("p", _hoisted_9, _toDisplayString(coopData.value.contactEmail || "-"), 1)
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("img", {
                                    src: coopData.value.qrCode || _unref(aboutImg),
                                    alt: "二维码",
                                    class: "qr-code"
                                }, null, 8, _hoisted_11),
                                _cache[2] || (_cache[2] = _createElementVNode("p", { class: "qr-text" }, "请使用微信扫一扫上方二维码", -1))
                            ])
                        ])
                    ])
                ]),
                _createVNode(post, {
                    ref_key: "postRef",
                    ref: postRef,
                    onSaved: refreshData
                }, null, 512)
            ]));
        };
    }
});
